import React from 'react';

import { useInternationalization } from '@progress/kendo-react-intl';

import { IWidgetCell } from '../../../../../types/IWidgetCell';

const AmountCell: React.FC<IWidgetCell> = ({ measureInfo, dataItem, field, rowType }) => {
  const intl = useInternationalization();

  let formattedAmount = intl.toString(dataItem[field], 'n2');

  if (rowType === 'groupHeader') {
    return null;
  }

  return (
    <td>
      <div className='alignment-right'>{measureInfo ? formattedAmount : dataItem[field]}</div>
    </td>
  );
};

export default AmountCell;
